import Home from "../scenes/auth/Home";
import {Route, Routes} from "react-router-dom";
import React from "react";
import PageNotFound from "../scenes/PageNotFound";

 function Index(){
     return (
         <Routes>
             <Route index path="/"  element={<Home/>}/>
             <Route path="*" element={<PageNotFound />} />
         </Routes>
     );
 }

export  default  Index;
